export default __webpack_public_path__ + "static/media/yellow_4.9087193c.png";